// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

class Slowmode {
	lastSendTimestamps: Record<string, number> = {};

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void this.initPersistence();
	}

	private async initPersistence(): Promise<void> {
		await makePersistent(this, 'Slowmode', ['lastSendTimestamps']);
	}

	recordMessageSend(channelId: string): void {
		this.lastSendTimestamps = {
			...this.lastSendTimestamps,
			[channelId]: Date.now(),
		};
	}

	updateSlowmodeTimestamp(channelId: string, timestamp: number): void {
		if (this.lastSendTimestamps[channelId] === timestamp) {
			return;
		}
		this.lastSendTimestamps = {
			...this.lastSendTimestamps,
			[channelId]: timestamp,
		};
	}

	deleteChannel(channelId: string): void {
		if (!this.lastSendTimestamps[channelId]) {
			return;
		}
		const {[channelId]: _, ...remainingTimestamps} = this.lastSendTimestamps;
		this.lastSendTimestamps = remainingTimestamps;
	}

	getLastSendTimestamp(channelId: string): number | null {
		return this.lastSendTimestamps[channelId] ?? null;
	}

	getSlowmodeRemaining(channelId: string, rateLimitPerUser: number): number {
		const lastSentTime = this.lastSendTimestamps[channelId];
		if (!lastSentTime) return 0;
		const timeSinceLastMessage = Date.now() - lastSentTime;
		return Math.max(0, rateLimitPerUser * 1000 - timeSinceLastMessage);
	}
}

export default new Slowmode();
